module.exports = __webpack_public_path__ + "img/tablet-acaiteria.0bde8bcd.png";